import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

import AppNameIcon from './AppName.svg?react';

const AppNameStyles = styled(AppNameIcon)`
  color: var(--text-color-black);
`;

export const AppName: React.FC<{
  className?: string;
}> = ({ className }) => {
  return <AppNameStyles className={classNames('app-name', className)} />;
};
